import { KnowledgeSourceModel, SingleKnowledgeBaseModel } from '../../../kb-api';

export const getKnowledgeSources = (knowledgeBase?: SingleKnowledgeBaseModel): KnowledgeSourceModel[] =>
  knowledgeBase?.draftStage ? knowledgeBase.draftKnowledgeSources : knowledgeBase?.originKnowledgeSources || [];
